import React, { useState } from 'react';

function Line() {
  return (
    <hr style={{ width: '91%'}}/>
  );
}

export default Line;